export enum OrderStatus {
  COMPLETED = 1,
  READY_FOR_DELIVERY = 2,
  OUT_FOR_DELIVERY = 3,
  DELIVERED = 4,
}
